module.exports = __webpack_public_path__ + "static/stories-dd96d6e86f9f1e0c889b73c27d92d6c1.png";